import PrimaryButton from '../../../ui-components/PrimaryButton'
import { openEliteLandingPage, trackEvent } from '../../../../utils/appBridge'
import { EventNames, type ElitePlanOfferType } from '../../../../types/misc.types'
import { EliteOfferBanner } from '../../../elite/landing-page/versions/landing-page-head/EliteOfferBanner'
import { useAppMetaContent } from '../../../../state-management/providers/AppMetaContentProvider'

const PostCountDownNonElite = ({
  specialOffering,
  signupOffer,
  offerStartTime,
  offerExpiryTime,
  offerType,
  membershipFees
}: {
  specialOffering?: boolean
  signupOffer?: boolean
  offerStartTime?: number | null
  offerExpiryTime?: number | null
  offerType?: ElitePlanOfferType | null
  membershipFees?: number
}) => {
  const { getEliteMembersDisplay } = useAppMetaContent()

  return (
    <div>
      <h2 className='text-[22px] font-medium text-orange10 text-left'>Available to Elite members only</h2>
      <div className='text-orange10 text-left mt-4 mb-8'>
        Unlock Power Rank, Power Rebalancing, Elite Scores and much more...
      </div>
      <EliteOfferBanner
        specialOffering={specialOffering ?? false}
        signupOffer={signupOffer ?? false}
        offerStartTime={offerStartTime}
        offerExpiryTime={offerExpiryTime}
        offerType={offerType}
        membershipFees={membershipFees ?? 0}
        source='PostCountDownNonElite'
        screenType='MF_Smart_Rebalancing'
      />
      <div className='relative'>
        <PrimaryButton
          isFullWidth
          label='Unlock Plan'
          aria-label='Unlock Plan, double tap to unlock plan'
          onClick={() => {
            trackEvent({
              eventName: EventNames.UserClicked,
              payload: {
                eventId: 'ExploreEliteClicked',
                ScreenName: 'PostCountDownNonElite',
                buttonLabel: 'Unlock Plan'
              }
            })
            openEliteLandingPage()
          }}
          labelClassName=''
          disabled={false}
        />
      </div>
      <div className='text-13 text-orange10 mt-3 text-center'>Trusted by {getEliteMembersDisplay('short')} Elite members</div>
    </div>
  )
}

export default PostCountDownNonElite
